import {
    createTheme,
  } from '@material-ui/core/styles';
const theme = createTheme({
    default: {
      borderRadius: '8px', // makes the corners square
      textTransform: 'none', // removes uppercase transformation
      lineHeight: '170%',
    },
    palette: {
   
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#229892',
        '&:hover': { // changes colors for button hover state
          backgroundColor: "#047A74",
          color: "#fff",
    
        },
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        main: '#47505E'
      },
  
    },
    button:{
      borderRadius:8
    }
  });
  
  theme.overrides = {
    MuiInputBase:{
      root: {
        height: 64
      }
    },
    MuiInputLabel:{
      root: {
        paddingTop:2
      }
   
    },
  
    MuiMenu:{
      root:{
        fontFamily:'inherit',
        fontSize:'inherit',
      },
      paper:{
        borderRadius: "8px",
        padding:0
      }
    },
    MuiListItem:{
     
      button:{
        '&:hover':{
          backgroundColor: "rgb(34 152 146 / 10%)",
        }
      }
    },
    MuiPaper:{
      root:{
        width: 182,
        height:192
      },
    },
    MuiMenuItem:{
      root:{
        width: '100%',
        height:64,
       
      },
    },
    MuiList:{
      padding:{
        padding:0,
        paddingTop:0,
        paddingBottom:0
      }
    },
    MuiOutlinedInput:{
      root: {
        height: 64
      },
      multiline:{
        height:153
      }
    },
    MuiFormControl:{
      root: {
        // height: 64
      }
    },
  }

  export default theme;